import { ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import { SubSectionData } from 'src/app/model/help';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
   selector: 'app-helper-subsection',
   templateUrl: './helper-subsection.component.html',
   changeDetection: ChangeDetectionStrategy.Default,
   providers: [DialogService]
})

export class HelperSubsectionComponent implements OnInit {
   @Input() subsection: SubSectionData;
   @Input() controller: boolean;
   @Input() mobile: boolean;

   subsectionData: SubSectionData;
   ref: DynamicDialogRef | undefined;

   constructor() {}

    ngOnInit() {
        this.subsectionData = this.subsection;
    }
}
